module.exports = __webpack_public_path__ + "static/media/IMG_2204.b6f28d2c.jpg";